const priceFormatter = new Intl.NumberFormat("sv-SE", {
    style: "currency",
    currency: "SEK",
    minimumSignificantDigits: 1,
});
const fromNumber = (price) => {
    return {
        toStringSEK: () => {
            const hasValue = price !== undefined || price !== null;
            if (!hasValue) {
                return undefined;
            }
            return priceFormatter.format(price);
        },
    };
};
export default {
    fromNumber,
};
